import { apiClient } from '../../../shared/api/client.js';
import type { EditionTreeResponse, CreateEditionInput, Book } from '../../../shared/types/index.js';

export const editionsApi = {
  async getEditionTree(idOrUibn: string): Promise<EditionTreeResponse> {
    return apiClient(`/api/editions/${encodeURIComponent(idOrUibn)}/tree`);
  },

  async createEdition(parentBookId: string, data: CreateEditionInput): Promise<{ message: string; book: Book }> {
    return apiClient(`/api/editions/${parentBookId}/branch`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async linkEdition(
    parentBookId: string,
    childBookId: string,
    editionType?: string,
    editionNotes?: string
  ): Promise<{ message: string; parentBook: Book; childBook: Book }> {
    return apiClient(`/api/editions/${parentBookId}/link`, {
      method: 'POST',
      body: JSON.stringify({ childBookId, editionType, editionNotes }),
    });
  },
};
